const template = require('./chart_details.html.slim')
declare var angular
import { includes, find } from 'lodash'

export class ChartDetails {
  static $inject = ['$routeParams', 'Accounts']

  account

  private _accounts
  private _data
  private _points

  constructor(private $routeParams, private Accounts) { }

  public getAccountName(number) {
    var account = find(this.accounts, { id: +number })
    return account ? account["name"] : ''
  }

  get accounts() { return this._accounts }
  set accounts(value) { this._accounts = value }

  get points() { return this._points }
  set points(value) {
    var excludedKeys = ['date', 'total']
    var points = []
    for (var key of Object.keys(value)) {
      if ( !includes(excludedKeys, key) ) {
        points.push( { id: key, value: value[key] } )
      }
    }

    this._points = points.reverse()
  }

  get data() { return this._data }
  set data(value) {
    if (value === undefined) { return }

    // Get dashboard info if in the single account view
    if (this.accounts === undefined) {
      this.account = this.getAccountDetails(value.date)
    } else {
      this.points = value
    }

    this._data = value
  }

  private getAccountDetails(date) {
    return this.Accounts.get({
      id: this.$routeParams.id,
      startDate: null,
      endDate: date,
      minimal: true,
    }, function(d) {
      return d
    })
  }
}

angular.module('wbComponents').directive('chartDetails', function() {
  return {
    restrict: 'E',
    controller: ChartDetails,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: template,
    scope: {
      data: '=',
      accounts: '='
    }
  }
})
